export const getSelectedDataset = (datasets: any, selectedLayer: string) => {
    return datasets.find((dataset: any) => dataset.dataset_id === selectedLayer);
};

// Utility function to handle nested attributes
export function getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined) ? acc[key] : undefined, obj);
}